import { useTranslation } from 'react-i18next';
import LogoImage from '@/components/base/LogoImage';

export default function Footer() {
  const { t } = useTranslation();

  const navLinks = ['Inicio', 'Catálogo', 'Nosotros', 'Testimonios', 'Contacto'];
  const cuts = [
    'Pernil',
    'Chivo',
    'Churrasco',
    'Mondongo',
    'Chicharrón',
  ];

  return (
    <footer className="bg-brand-charcoal text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1 text-center lg:text-left">
            <LogoImage
              variant="light"
              size="footer"
              className="mx-auto lg:mx-0 mb-5 justify-center lg:justify-start"
            />
            <p className="text-white font-semibold text-sm tracking-wide mb-2">
              L&J PREMIUM MEATS LLC
            </p>
            <p className="text-white/70 text-sm mb-1">
              1506 St Nicholas Ave, New York, NY 10033
            </p>
            <p className="text-white/70 text-sm mb-6">
              <a href="tel:+19177084424" className="hover:text-brand-gold transition-colors">
                917-708-4424
              </a>
              {' / '}
              <a href="tel:+13473606636" className="hover:text-brand-gold transition-colors">
                347-360-6636
              </a>
            </p>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-xs mx-auto lg:mx-0">
              {t('footer_desc')}
            </p>
            <div className="flex gap-3 justify-center lg:justify-start">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-all duration-300 hover:scale-110"
              >
                <i className="ri-instagram-line" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-all duration-300 hover:scale-110"
              >
                <i className="ri-facebook-line" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red transition-all duration-300 hover:scale-110"
              >
                <i className="ri-youtube-line" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="text-center lg:text-left">
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              {t('footer_nav')}
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="text-white/50 text-sm hover:text-brand-gold transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div className="text-center lg:text-left">
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              {t('footer_popular')}
            </h4>
            <ul className="space-y-2.5">
              {cuts.map((item) => (
                <li key={item}>
                  <span className="text-white/50 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center lg:text-left">
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              {t('footer_contact')}
            </h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3 justify-center lg:justify-start">
                <i className="ri-map-pin-line text-brand-gold mt-0.5" />
                <span className="text-white/50 text-sm">
                  1506 St Nicholas Ave
                  <br />
                  New York, NY 10033
                </span>
              </div>
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <i className="ri-phone-line text-brand-gold" />
                <span className="text-white/50 text-sm">(347) 360-6636</span>
              </div>
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <i className="ri-smartphone-line text-brand-gold" />
                <span className="text-white/50 text-sm">(917) 504-9095</span>
              </div>
              <div className="flex items-center gap-3 justify-center lg:justify-start">
                <i className="ri-smartphone-line text-brand-gold" />
                <span className="text-white/50 text-sm">(917) 708-4424</span>
              </div>
              <div className="flex items-center gap-2 mt-3 justify-center lg:justify-start">
                <div className="w-6 h-6 bg-brand-gold/20 rounded-full flex items-center justify-center">
                  <i className="ri-user-3-line text-brand-gold text-xs" />
                </div>
                <span className="text-white/40 text-xs">Javier, Luisa, Henry</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col items-center text-center sm:flex-row sm:text-left sm:items-center sm:justify-between gap-4">
          <p className="text-white/30 text-sm">{t('footer_copyright')}</p>
          <div className="flex gap-6">
            <a
              href="#"
              className="text-white/30 text-sm hover:text-white/50 transition-colors"
            >
              {t('footer_privacy')}
            </a>
            <a
              href="#"
              className="text-white/30 text-sm hover:text-white/50 transition-colors"
            >
              {t('footer_terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}